module.exports = __webpack_public_path__ + "img/img_platform05.a5d4be2a.jpg";